import React, {useEffect, useState} from 'react';
import {Col, Row} from 'react-bootstrap';
import {getLanguage, t} from 'react-switch-lang';
import {useUserContext} from '../../contexts/UserContext';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import RevisionsTable from './components/table/RevisionsTable';

import RevisionsFilter from './components/revisionsFilter/RevisionsFilter';
import {useHistory} from 'react-router-dom';
import {deleteRevisions} from '../../services/revisions';
import Prompt from '../../components/prompt/prompt';
import Toast from '../../components/toast/Toast';
import Swal from 'sweetalert2';
import {
  getRevisionSubTableColumns,
  getRevisionTableColumns,
  revisionsFilter,
  revisionSubTableColumns,
} from './const';
import roles from '../../utils/roles';
import {deleteFinding} from '../../services/findings';

const Revisions = () => {
  const [query, setQuery] = useState('');
  const [updateTable, setUpdateTable] = useState(0);
  const [allowCRUD, setAllowCRUD] = useState(false);
  const [allowEdit, setAllowEdit] = useState(false);
  const user = useUserContext();
  const departments = useDepartmentContext();
  let history = useHistory();

  const revisionRoles = [
    roles.role_internal_auditor,
    roles.role_head_of_internal_audit,
    roles.role_super_admin,
    roles.role_admin
  ];
  const allowedRoles = [
    roles.role_super_admin,
    roles.role_admin
  ];

  useEffect(() => {
    const result = allowedRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setAllowEdit(result.length > 0);
  }, [user]);
  useEffect(() => {
    const result = revisionRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setAllowCRUD(result.length > 0);
  }, [user]);
  const onFindingsDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteFinding'),
        text: t('question.deleteFinding'),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        preConfirm: async () => {
          try {
            const response = await deleteFinding(record?.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess2', {
                  entity: t('revisions.finding'),
                }),
                icon: 'success',
              });
              resolve(response);
              setUpdateTable((prevState) => prevState+1);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('Pages.messages.deleteError'),
              icon: 'error',
            });
          }
        },
      });
    });
  };
  const onRevisionDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteRevision'),
        text: t('question.deleteRevision'),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        preConfirm: async () => {
          try {
            const response = await deleteRevisions(record?.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess3', {
                  entity: t('common.revision'),
                }),
                icon: 'success',
              });
              resolve(response);
              setUpdateTable((prevState) => prevState+1);
            } else {
              reject(response);
            }
          } catch (err) {
            if (err?.response?.data?.code === 'revision-could-not-be-deleted') {
              Swal.fire({
                text: t('message.revisionCannotDelete'),
                icon: 'error',
              });
            } else {
              Swal.fire({
                text: t('Pages.messages.deleteError'),
                icon: 'error',
              });
            }
          }
        },
      });
    });
  };

  const columns = getRevisionTableColumns(history, onRevisionDelete, allowCRUD);
  const subTableColumns = getRevisionSubTableColumns(
    history,
    onFindingsDelete,
    allowCRUD,
    true,
    allowEdit
  );

  const filterSubmit = (data) => {
    const params = revisionsFilter(data);
    setQuery(params);

  };

  return (
    <>
      <div className="mx-5">
        <Row>
          <Col xs="12" lg="12" className="mt-4">
            {allowCRUD ? (
              <div className=" col-padding d-flex justify-content-end">
                <button
                  onClick={() => history.push('/revisions/add')}
                  type="button"
                  className="primary-btn mr-2"
                >
                  <img
                    src={process.env.PUBLIC_URL + '/images/whitePlus.svg'}
                    alt={'plusImg'}
                  />

                  <div className="ml-2">{t('buttons.addRevision')}</div>
                </button>
              </div>
            ) : (
              ''
            )}
          </Col>
        </Row>
        <RevisionsFilter
          submit={filterSubmit}
          user={user}
          departments={departments}
        />
        <RevisionsTable
          key={updateTable}
          columns={columns}
          api={'/revisions'}
          subTableColumns={subTableColumns}
          userId={user.id}
          query={query}
          onClickRow={(row) => {
            history.push({
              pathname: `/revisions/${row?.id}`,
            });
          }}
          subTableClickRow={(findingId, revisionId) => {
            history.push({
              pathname: `/revisions/${revisionId}/findings/${findingId}`,
            });
          }}
        />
      </div>
    </>
  );
};

export default Revisions;
